export default "/images/pr-img-7.png?965677203e5271e595104afdb657a895";